export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "delivery_collection": {
            "collection_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código"])},
            "quantity": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cantidad"])},
            "week": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Semana"])},
            "collected_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fecha de recolección"])},
            "delivery_product": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Producto"])},
            "delivery_employee": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Recolector"])},
            "delivery_process_provider": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Proveedor"])}
          }
        }
      }
    }
  })
}